<template>
    <div style="padding-top:50px">
        <h1>404</h1>
        <h3>Sorry, page not found.</h3>
         <i class="material-icons" style="font-size:50px">sentiment_very_dissatisfied</i>
    </div>
</template>

<script>
export default {
    name:"PageNotFound"
}
</script>


// WEBPACK FOOTER //
// src/components/PageNotFound.vue